(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReportToCompDialogController',ReportToCompDialogController);

    ReportToCompDialogController.$inject = ['$uibModalInstance','detailMessage'];

    function ReportToCompDialogController($uibModalInstance,detailMessage) {
        var vm = this;
        vm.confirm = confirm;
        vm.detailMessage = detailMessage;
        
        function confirm(numChoose) {
        	$uibModalInstance.close(numChoose);
        }
    }
})();
